import { ChangeDetectionStrategy, Component, OnInit, Inject, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { FormControl } from '@angular/forms';

// TODO Rename and put in its own module

@Component({
  selector: 'dl-recipients-list',
  templateUrl: './recipients-list.component.html',
  styleUrls: ['./recipients-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecipientslistComponent implements OnInit {
  public isLimit: boolean = false;
  public isWarn: boolean = false;
  public contacts: number;
  public accounts: number;
  
  public constructor(
    private _cdr: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {}

  public contactLimit(islimit: boolean){
    this.isLimit = islimit;
  }
  public contactWarn(iswarn: boolean){
    this.isWarn = iswarn;
    this._cdr.detectChanges();
  }
  public contactData(dataCount: any[]){
    this.contacts = dataCount[0];
    this.accounts = dataCount[1];
    this._cdr.detectChanges();
  }
}
